import { FormSection, Link, Timeline } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { ServiceCode } from '@common/enums/serviceCode';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

interface ITcchRequestFollowingStepsProps {
    serviceCode: ServiceCode.TCCh | ServiceCode.TCCr;
}

export function RequestConsultFollowingSteps({ serviceCode }: ITcchRequestFollowingStepsProps) {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    return (
        <FormSection
            title={
                serviceCode === ServiceCode.TCCh
                    ? 'Vervolgstappen consult holteronderzoek'
                    : 'Vervolgstappen consult rust ECG'
            }
        >
            <Timeline>
                <Timeline.Item>De Ksyos cardioloog ontvangt de consultaanvraag</Timeline.Item>
                <Timeline.Item>Deze cardioloog beantwoordt de vraag digitaal</Timeline.Item>
                <Timeline.Item>
                    Binnen 2 werkdagen na het onderzoek ontvang je de uitslag in het Ksyos platform en via Edifact in je
                    HIS als je je{' '}
                    <Link
                        openInNewTab={true}
                        to={`/employments/${selectedEmploymentId}/personalSettings`}
                        variant="link"
                    >
                        zorgmailnummer hebt doorgegeven
                    </Link>
                </Timeline.Item>
                <Timeline.Item>Optioneel: Je stelt een aanvullende consultvraag aan de cardioloog</Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
